import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";

import Area from "../../global/Area";
import Education from "./Education";
import Technology from "./Technology";
import Society from "./Society";
import Environment from "./Environment";


class SummaryArea extends Component {
    constructor(props) {
        super(props);
    }

    getMoreArrayLength = (object) => {
        return Object.values(object).filter(item => item.likeMore === true).length
    };

    render() {
        return (
            <Area click={this.props.click} additionalClass={this.props.additionalClass}>
                <Fragment>
                    {this.props.area === 'society' &&
                        <Society click={this.props.click} survey={this.props.survey.society.questions}/>
                    }
                    {this.props.area === 'technology' &&
                        <Technology click={this.props.click} survey={this.props.survey.technology.questions}/>
                    }
                    {this.props.area === 'education' &&
                        <Education click={this.props.click} survey={this.props.survey.education.questions}/>
                    }
                    {this.props.area === 'environment' &&
                        <Environment click={this.props.click} survey={this.props.survey.environment.questions}/>
                    }

                    <div className="counter">
                        <mark>{this.getMoreArrayLength(this.props.test[this.props.area].answers)}</mark>
                        /{Object.keys(this.props.test[this.props.area].answers).length}
                    </div>
                </Fragment>
            </Area>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        survey: state.survey,
        test: state.test,
    }
};

export default connect(mapStateToProps)(SummaryArea);


// WEBPACK FOOTER //
// ./sources/js/components/Summary/graph/SummaryArea.js